import React, { useState } from 'react';
import { FileUploader } from '../common/FileUploader';
export function Product() {
  const [selectedCategory, setSelectedCategory] = useState('Product Details');
  const categories = ['Product Details', 'Policy Wordings', 'Underwriting Guidelines', 'Pricing Models', 'Claims Procedures', 'Risk Assessment Documents'];
  return <div className="bg-white rounded-lg shadow" data-id="element-2470">
      <div className="p-6" data-id="element-2471">
        <h2 className="text-xl font-semibold mb-6" data-id="element-2472">Product Information</h2>

        <div className="grid grid-cols-1 gap-6 mb-6" data-id="element-2473">
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-2474">
            <h3 className="font-medium text-lg mb-4" data-id="element-2475">Product Overview</h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-2476">
              <div data-id="element-2477">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2478">
                  Product Line
                </label>
                <select className="w-full p-2 border rounded-md" data-id="element-2479">
                  <option data-id="element-2480">Property</option>
                  <option data-id="element-2481">Casualty</option>
                  <option data-id="element-2482">Marine</option>
                  <option data-id="element-2483">Motor</option>
                  <option data-id="element-2484">Life</option>
                  <option data-id="element-2485">Health</option>
                  <option data-id="element-2486">Specialty</option>
                </select>
              </div>
              <div data-id="element-2487">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2488">
                  Target Market
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. Small Business Owners" data-id="element-2489" />
              </div>
              <div data-id="element-2490">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2491">
                  Geographic Coverage
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. United Kingdom" data-id="element-2492" />
              </div>
              <div data-id="element-2493">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2494">
                  Average Premium (£)
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. 1,500" data-id="element-2495" />
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-2496">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-2497">
            <h3 className="font-medium text-lg mb-4" data-id="element-2498">Product Documents</h3>
            <div className="mb-4" data-id="element-2499">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2500">
                Document Category
              </label>
              <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-2501">
                {categories.map(category => <option key={category} value={category} data-id="element-2502">
                    {category}
                  </option>)}
              </select>
            </div>
            <FileUploader data-id="element-2503" />
            <div className="mt-6 text-sm text-gray-500" data-id="element-2504">
              <p data-id="element-2505">Acceptable document formats: PDF, DOC, DOCX, XLS, XLSX</p>
              <p data-id="element-2506">Maximum file size: 10MB</p>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 overflow-y-auto max-h-[600px]" data-id="element-2507">
            <h3 className="font-medium text-lg mb-4" data-id="element-2508">Document Requirements</h3>
            <div className="space-y-4" data-id="element-2509">
              <div data-id="element-2510">
                <h4 className="font-medium" data-id="element-2511">Product Details</h4>
                <p className="text-sm text-gray-600" data-id="element-2512">
                  Detailed description of insurance products including coverage,
                  limits, and exclusions.
                </p>
              </div>

              <div data-id="element-2513">
                <h4 className="font-medium" data-id="element-2514">Policy Wordings</h4>
                <p className="text-sm text-gray-600" data-id="element-2515">
                  Sample policy documents and terms & conditions for each
                  product.
                </p>
              </div>

              <div data-id="element-2516">
                <h4 className="font-medium" data-id="element-2517">Underwriting Guidelines</h4>
                <ul className="text-sm text-gray-600 space-y-1 mt-2" data-id="element-2518">
                  <li className="flex items-start" data-id="element-2519">
                    <span className="mr-2" data-id="element-2520">•</span>
                    <span data-id="element-2521">Risk appetite statements</span>
                  </li>
                  <li className="flex items-start" data-id="element-2522">
                    <span className="mr-2" data-id="element-2523">•</span>
                    <span data-id="element-2524">Exclusions and limitations</span>
                  </li>
                  <li className="flex items-start" data-id="element-2525">
                    <span className="mr-2" data-id="element-2526">•</span>
                    <span data-id="element-2527">Referral procedures and criteria</span>
                  </li>
                </ul>
              </div>

              <div data-id="element-2528">
                <h4 className="font-medium" data-id="element-2529">Pricing Models</h4>
                <p className="text-sm text-gray-600" data-id="element-2530">
                  Documentation on how premiums are calculated and risk factors
                  considered.
                </p>
              </div>

              <div data-id="element-2531">
                <h4 className="font-medium" data-id="element-2532">Exposure Data</h4>
                <ul className="text-sm text-gray-600 space-y-1 mt-2" data-id="element-2533">
                  <li className="flex items-start" data-id="element-2534">
                    <span className="mr-2" data-id="element-2535">•</span>
                    <span data-id="element-2536">Limit profile by policy</span>
                  </li>
                  <li className="flex items-start" data-id="element-2537">
                    <span className="mr-2" data-id="element-2538">•</span>
                    <span data-id="element-2539">Geographical distribution of risks</span>
                  </li>
                  <li className="flex items-start" data-id="element-2540">
                    <span className="mr-2" data-id="element-2541">•</span>
                    <span data-id="element-2542">Industry/sector breakdown</span>
                  </li>
                  <li className="flex items-start" data-id="element-2543">
                    <span className="mr-2" data-id="element-2544">•</span>
                    <span data-id="element-2545">Attachment points and retention levels</span>
                  </li>
                </ul>
              </div>

              <div data-id="element-2546">
                <h4 className="font-medium" data-id="element-2547">Claims Handling Process</h4>
                <ul className="text-sm text-gray-600 space-y-1 mt-2" data-id="element-2548">
                  <li className="flex items-start" data-id="element-2549">
                    <span className="mr-2" data-id="element-2550">•</span>
                    <span data-id="element-2551">Claims handling procedures overview</span>
                  </li>
                  <li className="flex items-start" data-id="element-2552">
                    <span className="mr-2" data-id="element-2553">•</span>
                    <span data-id="element-2554">TPA involvement (if applicable)</span>
                  </li>
                  <li className="flex items-start" data-id="element-2555">
                    <span className="mr-2" data-id="element-2556">•</span>
                    <span data-id="element-2557">Claims authority limits</span>
                  </li>
                </ul>
              </div>

              <div data-id="element-2558">
                <h4 className="font-medium" data-id="element-2559">
                  Key Personnel & Underwriting Experience
                </h4>
                <ul className="text-sm text-gray-600 space-y-1 mt-2" data-id="element-2560">
                  <li className="flex items-start" data-id="element-2561">
                    <span className="mr-2" data-id="element-2562">•</span>
                    <span data-id="element-2563">CVs of key underwriting personnel</span>
                  </li>
                  <li className="flex items-start" data-id="element-2564">
                    <span className="mr-2" data-id="element-2565">•</span>
                    <span data-id="element-2566">Team structure and reporting lines</span>
                  </li>
                  <li className="flex items-start" data-id="element-2567">
                    <span className="mr-2" data-id="element-2568">•</span>
                    <span data-id="element-2569">Relevant experience in class of business</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}